import { useFragment } from "@apollo/client/react";

import { SearchSuggestionsInput, SearchSuggestionsOutput } from "types/generated";

import useIntentProjectsFiltersVariables from "./useFiltersVariables";
import { SEARCH_INTENT_PROJECTS_SUGGESTIONS_FILTERED_COUNT_FRAGMENT } from "./gql";

const useAllItemsCount = () => {
  const { fullTextSearch, predicates } = useIntentProjectsFiltersVariables();

  const { data } = useFragment<
    { searchIntentProjectsSuggestions: Pick<SearchSuggestionsOutput, "filteredCount"> },
    { input: SearchSuggestionsInput }
  >({
    fragment: SEARCH_INTENT_PROJECTS_SUGGESTIONS_FILTERED_COUNT_FRAGMENT,
    from: {
      __typename: "Query",
    },
    variables: {
      input: {
        fullTextSearch,
        predicates,
        fields: null,
      },
    },
  });

  const allItemsCount = data?.searchIntentProjectsSuggestions?.filteredCount || 0;

  return {
    allItemsCount,
  };
};

export default useAllItemsCount;
